<template>
  <div>
    <div class="intro-y flex justify-end">
      <InputSelect
        :first-item-label="$t('text.pleaseSelectAnAction')"
        first-item-disabled
        :options="createOptions(customer.status)"
        value-key="id"
        v-model="customerAction"
        @input="confirmChangeStatus"
        :disabled="changingStatus || isViewer()"
      />
    </div>
    <div class="intro-y grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 lg:col-span-6">
        <CustomerInfoOther :customer="customer" class="intro-y" />
        <CustomerInfoFinancial :customer="customer" class="intro-y mt-5" />
        <CustomerInfoPassportImages
          :customer="customer"
          class="intro-y mt-5"
          :disabled="isViewer()"
        />
        <CustomerInfoSelfImages :customer="customer" class="intro-y mt-5" :disabled="isViewer()" />
      </div>
      <div class="col-span-12 lg:col-span-6">
        <CustomerInfoBank :customer="customer" class="intro-y" :disabled="isViewer()" />
        <CustomerInfoEmergencyContacts :customer="customer" class="intro-y mt-5" />
        <CustomerInfoDependentCustomers :customer="customer" class="intro-y mt-5" />
        <CustomerInfoNote class="intro-y mt-5" :disabled="isViewer()" />
        <CustomerInfoHistory :customer="customer" class="intro-y mt-5" />
      </div>
    </div>

    <ConfirmDialog
      :modal-id="confirmModalId"
      :loading="changingStatus"
      status="warning"
      @ok="onChangeStatus"
      @cancelled="customerAction = null"
      disable-backdrop
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_CHANGE_STATUS_REQUEST } from '@/store/actions/customer';
import InputSelect from '@/components/ui/input/InputSelect';
import CustomerInfoFinancial from '@/components/customer/CustomerInfoFinancial';
import CustomerInfoOther from '@/components/customer/CustomerInfoOther';
import CustomerInfoBank from '@/components/customer/CustomerInfoBank';
import CustomerInfoEmergencyContacts from '@/components/customer/CustomerInfoEmergencyContacts';
import CustomerInfoDependentCustomers from '@/components/customer/CustomerInfoDependentCustomers';
import CustomerInfoPassportImages from '@/components/customer/CustomerInfoPassportImages';
import CustomerInfoSelfImages from '@/components/customer/CustomerInfoSelfImages';
import CustomerInfoNote from '@/components/customer/CustomerInfoNote';
import CustomerInfoHistory from '@/components/customer/CustomerInfoHistory';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import meMixin from '../../mixins/meMixin';

export default {
  mixins: [meMixin],

  props: {
    customer: Object,
  },

  data() {
    return {
      confirmModalId: 'status-change-confirm-dialog',
      customerAction: null,
      pendingActions: [
        { id: 'check', name: this.$t('statusActions.check') },
        { id: 'put-black-list', name: this.$t('statusActions.blacklist') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      checkedActions: [
        { id: 'request', name: this.$t('statusActions.request') },
        { id: 'put-black-list', name: this.$t('statusActions.blacklist') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      approvedActions: [
        { id: 'check', name: this.$t('statusActions.check') },
        { id: 'request', name: this.$t('statusActions.request') },
        { id: 'put-black-list', name: this.$t('statusActions.blacklist') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      requestedActions: [
        { id: 'check', name: this.$t('statusActions.check') },
        { id: 'confirm', name: this.$t('statusActions.confirm') },
        { id: 'put-black-list', name: this.$t('statusActions.blacklist') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      confirmedActions: [{ id: 'put-black-list', name: this.$t('statusActions.blacklist') }],
      contractedActions: [
        { id: 'check', name: this.$t('statusActions.check') },
        { id: 'put-black-list', name: this.$t('statusActions.blacklist') },
        { id: 'confirm', name: this.$t('statusActions.confirm') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      blacklistedActions: [
        { id: 'check', name: this.$t('statusActions.check') },
        { id: 'remove-black-list', name: this.$t('statusActions.removeBlacklist') },
        { id: 'not-matched', name: this.$t('statusActions.notMatched') },
      ],
      notMatchedActions: [
        { id: 'restore-not-matched', name: this.$t('statusActions.restoreNotMatched') },
      ],
    };
  },

  computed: {
    ...mapGetters(['customerStatus']),
    changingStatus() {
      return this.customerStatus === 'changing';
    },
  },

  methods: {
    createOptions(status) {
      let actions = [];
      if (status === 'PENDING') {
        actions = this.pendingActions;
      }
      if (status === 'CHECKED') {
        actions = this.checkedActions;
      }
      if (status === 'APPROVED') {
        actions = this.approvedActions;
      }
      if (status === 'REQUESTED') {
        actions = this.requestedActions;
      }
      if (status === 'CONFIRMED') {
        actions = this.confirmedActions;
      }
      if (status === 'CONTRACTED') {
        actions = this.contractedActions;
      }
      if (status === 'BLACKLISTED') {
        actions = this.blacklistedActions;
      }
      if (status === 'NOT_MATCHED') {
        actions = this.notMatchedActions;
      }

      if (this.isCollectionsOfficer()) {
        return actions.filter(action => action.id !== 'confirm');
      }

      return actions;
    },
    confirmChangeStatus() {
      cash(`#${this.confirmModalId}`).modal('show');
    },
    async onChangeStatus() {
      const payload = {
        id: this.customer.id,
        action: this.customerAction,
      };
      await this.$store.dispatch(CUSTOMER_CHANGE_STATUS_REQUEST, payload);
      if (this.customerStatus === 'success') {
        window.location.reload();
      }
    },
  },

  components: {
    InputSelect,
    CustomerInfoFinancial,
    CustomerInfoOther,
    CustomerInfoBank,
    CustomerInfoEmergencyContacts,
    CustomerInfoDependentCustomers,
    CustomerInfoPassportImages,
    CustomerInfoSelfImages,
    CustomerInfoNote,
    CustomerInfoHistory,
    ConfirmDialog,
  },
};
</script>
